<template>
  <div>
    <el-row>
        <el-col :span="4" class="navigation">
            <ul class="title">
                <li class="flex justify-between" style="margin-bottom:20px;">
                    <div  class="meau flex  align-center">
                        <img src="../../assets/images/cooperateManagement/meau.png" alt=""><span style="font-size:25px;font-weight: 700;">任务</span>
                    </div>
                    <img src="../../assets/images/cooperateManagement/more.png" alt="">
                </li>
                <li class="flex justify-between" style="margin-bottom:20px;">
                    <div class="meau  flex  align-center">
                        <img src="../../assets/images/cooperateManagement/member.png" alt=""><span>我负责的</span>
                    </div>
                    <div>3</div>
                </li>
                <li class="flex justify-between" style="margin-bottom:20px;">
                    <div  class="meau  flex  align-center">
                        <img src="../../assets/images/cooperateManagement/collect.png" alt=""><span>我关注的</span>
                    </div>
                    <div>3</div>
                </li>
               
                <li style="padding-left: 40px;border-top: 2px solid #dee1e6;">
                    <el-collapse v-model="activeNames1" @change="handleChangeTitle1">
                        <el-collapse-item title="快速访问" name="1">
                            <div v-for="item in fastmeauList" :key="item">{{ item }}</div>  
                        </el-collapse-item>
                    </el-collapse>
                </li>
                <li style="position: relative;border-top: 2px solid #dee1e6;" >  
                    <el-collapse v-model="activeNames2" @change="handleChangeTitle2">
                        <el-collapse-item>
                            <template slot="title">
                                <i class="el-icon-plus" @click="addProject" style="font-size: 25px;margin-right: 15px;"></i>协作清单
                            </template>
                            <div v-for="(item, index) in cooperateList" :key="index"  :class="activeProjectIndex ==index?'activeproject':''" 
                            @click="activeNowProject(index)" class="projectname"
                            >
                                {{ item }}</div>
                        </el-collapse-item>
                    </el-collapse>
                </li>
            </ul>
           
        </el-col>
        <el-col :span="20" style="padding-left:30px;">
            <!-- 项目名称 -->
            <div class="projecttitle flex justify-between align-center">
                <div class="name flex align-center" style="position: relative;">
                    <div class="bigtitle">三瓜公司333333333333333333</div>
                    <img src="../../assets/images/cooperateManagement/more.png" alt="" @click="showBigMeau" style="width:40px;height:40px;margin-left: 15px;" >
                    <div class="bigMeau" v-show="isShowBigmeau">
                        <div class="flex align-center" style="margin-bottom:10px;" @click="shareProject">
                            <img src="../../assets/images/cooperateManagement/share.png" alt=""  style="margin-right:10px;">
                           <span>分享</span>
                        </div>
                        <div class="flex align-center"  style="margin-bottom:10px;"  @click="changeProjectname">
                            <img src="../../assets/images/cooperateManagement/resertname.png" alt=""  style="margin-right:10px;">
                           <span>重命名</span>
                        </div>
                        <div class="flex align-center"  style="margin-bottom:10px;"  @click="deleteProject">
                            <img src="../../assets/images/cooperateManagement/delete.png" alt="" style="margin-right:10px;">
                           <span style="color:red;">删除</span>
                        </div>
                    </div>
                </div>
                <div class="memberlogo">
                    <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="">
                </div>
            </div>
            <!-- tab 栏 -->
            <div class="tabs flex">
                <div v-for="(item, index) in tabsList" :key="index"
                @click="changeTap"
                :data-index="index"
                class="onetab"
                :class="index == activeIndex ? 'activetab' : 'normaltab'"
                >{{ item }}</div>
            </div>
            <!-- 列表1 -->
            <div class="firsttab"   v-if="activeIndex == '0'">
                <div class="addnewTaskbox flex align-center">
                    <div class="addnewTaskbox1 flex align-center" @click="showInputDefaulttask">
                        <img src="../../assets/images/cooperateManagement/blueadd.png" alt="">
                        <div>新建任务</div>                     
                    </div>
                    <div class="addnewTaskbox2 flex align-center">
                        <img src="../../assets/images/cooperateManagement/blueselect.png" alt="">
                    </div>
                </div>
                <div class="graytext">
                    <el-col :span="8" >任务标题</el-col>
                    <el-col :span="3" >负责人</el-col>
                    <el-col :span="5" >截止时间</el-col>
                    <el-col :span="4">创建人</el-col>
                </div>
                <div class="content1">
                    <!-- 默认分组 -->
                    <el-collapse>
                        <el-collapse-item>
                            <template slot="title">
                                <div style="position: relative">
                                    <i class="el-icon-caret-bottom" style="margin-right:5px;font-size: 20px;"></i>
                                    默认分组
                                    <span style="margin-left:25px; color: #c0c4c8;"></span>
                                </div>
                            </template>
                            <div>
                                <el-row v-if="isShowInputDefaulttask">
                                    <el-col :span="6" >
                                        <div class="flex align-center"> 
                                            <i class="el-icon-caret-right" style="margin-right:5px;font-size: 20px;"></i>
                                            <el-input v-model="inputDefaultTaskname"  @keyup.enter.native="addDefaultTask" clearable placeholder="请输入内容，回车即可添加任务"></el-input>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row class="bottomborder flex align-center" @dblclick.native="showDrawer" v-for="(item,index) in defaultList" :key="index" style="margin-top:20px;">
                                    <el-col :span="8" class="smalltaskname flex align-center">
                                        <el-checkbox v-model="item.status " @change="changeDefaulttaskStatus(item.status)" style="margin-right:5px;"></el-checkbox>
                                        <i class="el-icon-caret-right" style="margin-right:5px;font-size: 15px;"></i>
                                        <div :class="item.status ? 'distoryTaskname' : ''">{{ item.smalltaskname }}</div>
                                    </el-col>
                                    <el-col :span="3" >
                                        <div v-if="item.dutyleader" class="flex align-center">
                                            <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right: 10px;">
                                            {{ item.dutyleader }}
                                        </div>
                                        <div class="flex align-center positionr" v-else >
                                            <el-popover
                                                placement="right"
                                                width="170"
                                                trigger="click">
                                                <div  class="dutyList">
                                                    <el-input placeholder="请选择责任人" v-model="dutyleader" style="width:170px;"></el-input>
                                                    <div v-for="(item,index) in dutyList" :key="index" @click="selectedThisdutyLeader(index,'defaultTask')" class="flex align-center" style=" margin-top: 8px;">
                                                        <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right:10px;margin-left:10px;">
                                                        <div>{{ item.dutyname }}</div>
                                                    </div>
                                                </div>
                                            <i class="el-icon-s-custom" slot="reference" @click="showDutyleaderList(index)" style="margin-right:5px;font-size: 20px;color:#bababe;"></i>
                                            </el-popover>    
                                        </div>
                                    </el-col>
                                    <el-col :span="5" >
                                        <div v-if="item.time">{{ item.time }}</div>
                                        <div class="selecttime" v-else>
                                            <el-date-picker
                                                v-model="endtime"
                                                type="datetime"
                                                placeholder="选择日期时间">
                                            </el-date-picker>
                                        </div>
                                    </el-col>
                                    <el-col :span="4"  class="flex align-center">
                                        <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right: 10px;">
                                        {{ item.creator }}
                                    </el-col>
                                </el-row> 
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                    <!-- 其他分组 -->
                    <el-collapse v-for="(item, index1) in TaskList" :key="index1">
                        <el-collapse-item>
                            <template slot="title">
                                <div style="position: relative">
                                    <i class="el-icon-caret-bottom" style="margin-right:5px;font-size: 20px;"></i>
                                    {{item.taskname}}
                                    <span style="margin-left:25px; color: #c0c4c8;">{{ item.tasknum }}</span>
                                    <el-tooltip  effect="dark" content="新建任务到此分组" placement="top">
                                        <i class="el-icon-plus" style="margin-left:20px;font-size: 15px;" @click.stop="showInputSecondTask(index1)"></i>
                                    </el-tooltip>
                                    <i class="el-icon-more" style="margin-left:15px;font-size: 15px;" @click.stop="showTwomeau(index1)"></i>
                                    <div class="twoMeau" v-show="(taskIndex ===index1 ?true:false)  && isShowTwomeau"> 
                                        <div class="flex align-center"  style="line-height: 30px;" @click.stop="changeTaskName(index1)">
                                            <img src="../../assets/images/cooperateManagement/resertname.png" alt=""  style="margin-right:10px;">
                                           <span>重命名</span>
                                        </div>
                                        <div class="flex align-center"  style="line-height: 30px;" @click.stop="deleteTaskName(index1)">
                                            <img src="../../assets/images/cooperateManagement/delete.png" alt="" style="margin-right:10px;">
                                           <span style="color:red;">删除分组</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div>
                                <el-row v-if="taskIndex===index1?true:false">
                                    <el-col :span="6" >
                                        <div class="flex align-center"> 
                                            <i class="el-icon-caret-right" style="margin-right:5px;font-size: 20px;"></i>
                                            <el-input v-model="inputSecondTaskname"  @keyup.enter.native="addSecondTask" clearable placeholder="请输入内容，回车即可添加任务"></el-input>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row class="bottomborder flex align-center" @dblclick.native="showDrawer(list1)" v-for="(list1,index2) in item.childtask" :key="index2" style="margin-top:20px;">
                                    <el-col :span="8" class="smalltaskname flex align-center">
                                        <el-checkbox v-model="list1.status " @change="changeSecondtaskStatus(list1.status)" style="margin-right:5px;"></el-checkbox>
                                        <i class="el-icon-caret-right" style="margin-right:5px;font-size: 15px;"></i>
                                        <div :class="list1.status ? 'distoryTaskname' : ''"  >{{ list1.smalltaskname }}</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div v-if="list1.dutyleader" class="flex align-center">
                                            <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right: 10px;">
                                            {{ list1.dutyleader }}
                                        </div>
                                        <div class="flex align-center positionr" v-else >
                                            <el-popover
                                                placement="right"
                                                width="170"
                                                trigger="click">
                                                <div  class="dutyList">
                                                    <el-input placeholder="请选择责任人" v-model="dutyleader" style="width:170px;"></el-input>
                                                    <div v-for="(item,index) in dutyList" :key="index" @click="selectedThisdutyLeader(index,'otherTask')" class="flex align-center" style=" margin-top: 8px;">
                                                        <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right:10px;margin-left:10px;">
                                                        <div>{{ item.dutyname }}</div>
                                                    </div>
                                                </div>
                                                <i class="el-icon-s-custom" slot="reference" @click="showOtherDutyleaderList(index1,index2)" style="margin-right:5px;font-size: 20px;color:#bababe;"></i>
                                            </el-popover>
                                            
                                            <!-- <div class="dutyList "  v-show="(otherIndex===index1?true:false)&&(childIndex===index2?true:false)&&showOtherDutyList">
                                                <el-input placeholder="请选择责任人" v-model="dutyleader" style="width:170px;"></el-input>
                                                <div v-for="(item,index) in dutyList" :key="index" @click="selectedThisdutyLeader(index,'otherTask')" class="flex align-center oneduty">
                                                    <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right:10px;margin-left:10px;">
                                                    <div>{{ item.dutyname }}</div>
                                                </div>
                                            </div> -->
                                        </div>
                                    </el-col>
                                    <el-col :span="5" >{{ list1.time }}</el-col>
                                    <el-col :span="4"  class="flex align-center">
                                        <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right: 10px;">
                                        {{ list1.creator }}
                                    </el-col>
                                </el-row> 
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                    <el-row v-if="isShowInputFirstTask">
                        <el-col :span="6" >
                            <div class="flex align-center"> 
                                <i class="el-icon-caret-right" style="margin-right:5px;font-size: 20px;"></i>
                                <el-input v-model="inputFirstTaskname" @keyup.enter.native="addTask" clearable placeholder="请输入分组标题，回车即可添加分组" ></el-input>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:15px;">
                        <el-col :span="6">
                            <i class="el-icon-plus" style="margin-right:5px;font-size: 20px;color: #c0c4c8;"></i><span style="color: #c0c4c8;"  @click="showInputtask">新建分组</span>
                        </el-col>
                    </el-row>
                </div>
            </div>
             <!-- 内容2 -->
            <div class="secondtab"  v-if="activeIndex == '1'">
                <div class="addnewTaskbox flex align-center">
                    <div class="addnewTaskbox1 flex align-center" @click="showInputDefaulttask">
                        <img src="../../assets/images/cooperateManagement/blueadd.png" alt="">
                        <div>新建任务</div>                     
                    </div>
                    <div class="addnewTaskbox2 flex align-center">
                        <img src="../../assets/images/cooperateManagement/blueselect.png" alt="">
                    </div>
                </div>
                <div class="content2 flex">
                    <div class="defaultblock" style="margin-right:20px;">
                        <div class="blocktitle">默认分组</div>
                        <div class="oneblock" v-if="isShowInputDefaulttask">
                            <div class="flex align-center" >
                                <el-checkbox  style="margin-right:5px;"></el-checkbox>
                                <el-input v-model="inputDefaultTaskname"  @keyup.enter.native="addDefaultTask" clearable placeholder="输入内容，回车即可添加任务"></el-input>
                            </div>
                            <div class="time-member flex align-center" style="margin-top:10px;">

                                <el-date-picker
                                  v-model="endtime"
                                  type="datetime"
                                  placeholder="选择日期时间">
                                </el-date-picker>
                                <div class="memberbox flex align-center justify-center">
                                    <div class="memberlogo"><img src="../../assets/images/cooperateManagement/memberlogo.png" alt=""></div>
                                    <!-- <div class="memberlogo"><img src="../../assets/images/cooperateManagement/memberlogo.png" alt=""></div> -->
                                    <i class="el-icon-user" style="font-size: 20px;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="oneblock"   v-for="(item,index) in defaultList" :key="index">
                            <div class="flex align-center">
                                <el-checkbox v-model="item.status " @change="changeDefaultBlocktask(index)" style="margin-right:5px;"></el-checkbox>
                                <div>{{ item.smalltaskname }}</div>
                            </div>
                            <div class="time-member flex align-center" style="margin-top:10px;">
                                <el-date-picker
                                  v-model="item.time"
                                  type="datetime"
                                  placeholder="选择日期时间">
                                </el-date-picker>
                                <div class="memberbox flex align-center justify-center">
                                    <div class="memberlogo"><img src="../../assets/images/cooperateManagement/memberlogo.png" alt=""></div>                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="otherblock" v-for="(item, index) in TaskList" :key="index"  style="margin-right:20px;">
                        <div class="blocktitle">
                            <span>{{item.taskname}}</span><span style="margin-left:25px; color: #c0c4c8;">{{item.tasknum}}</span>
                        </div> 
                        <div class="oneblock"  v-for="(list1,index) in item.childtask" :key="index">
                            <div class="flex align-center">
                                <el-checkbox v-model="list1.status " @change="changeSecondtaskStatus(list1.status)" style="margin-right:5px;"></el-checkbox>
                                <div :class="list1.status ? 'distoryTaskname' : ''">{{ list1.smalltaskname }}</div>
                            </div>
                            <div class="time-member flex align-center" style="margin-top:10px;">
                                <el-date-picker
                                  v-model="list1.time"
                                  type="datetime"
                                  placeholder="选择日期时间">
                                </el-date-picker>
                                <div class="memberbox flex align-center justify-center">
                                    <div class="memberlogo"><img src="../../assets/images/cooperateManagement/memberlogo.png" alt=""></div>                                  
                                </div>
                            </div>
                        </div>
                        <div class="oneblock" v-if="taskIndex===index?true:false">
                            <div class="flex align-center" >
                                <el-input v-model="inputSecondTaskname" @keyup.enter.native="addSecondTask" clearable placeholder="输入内容，回车即可添加任务" ></el-input>
                            </div>el-input
                            
                        </div>
                        <div>
                            <i class="el-icon-plus" style="margin-right:5px;font-size: 20px;color: #c0c4c8;"></i>
                            <span style="color: #c0c4c8;"  @click="showInputSecondTask(index)">新建任务</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-col>  
    </el-row>
       <!-- 添加协作清单-->
    <el-dialog
      title="标题"
      :visible.sync="dialogVisibleAddProject"
      width="30%"
      :before-close="handleCloseAddProject"
    >   <div  style="margin-top:10px;" v-if="isForm=='bigName'?true:false">
            <div style="color: #333333;font-weight: 700;font-size: 14px;">清单名称：<span style="color:red;">*</span></div>
            <el-input  v-model="newBigName" clearable style="width: 200px;margin-top: 10px;"  placeholder="请输入新的清单名称" ></el-input>
        </div>
        <div  style="margin-top:10px;" v-if="isForm=='taskName'?true:false">
            <div style="color: #333333;font-weight: 700;font-size: 14px;">任务标题<span style="color:red;">*</span></div>
            <el-input  v-model="newTaskName" clearable style="width: 200px;margin-top: 10px;"  placeholder="请输入新的任务标题" ></el-input>
        </div>
        <div  style="margin-top:10px;" v-if="isForm=='addProject'?true:false">
            <div style="color: #333333;font-weight: 700;font-size: 14px;">清单名称：<span style="color:red;">*</span></div>
            <el-input  v-model="projectName" clearable style="width: 200px;margin-top: 10px;"  placeholder="请输入清单名称" ></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancelAddProject()">取 消</el-button>
            <el-button type="primary" @click="saveAddProject()">创 建</el-button>
        </span>
    </el-dialog>
    <!-- 抽屉 -->
    <el-drawer
        title=""
        :visible.sync="isShowdrawer"
    >
        <div class="drawer">
            <div class="flex  align-center currsmalltaskname">
                <el-checkbox v-model="currSmalltask.status" @change="changeDefaulttaskStatus(currSmalltask.status)" style="font-size: 20px;margin-right:10px;color: #bababe;"></el-checkbox>
                <div :class="currSmalltask.status ? 'distoryTaskname' : ''" >{{ currSmalltask.smalltaskname }}</div>
            </div>
            <div class="flex  align-center marginbot15" >
                <i class="el-icon-chat-line-square" style="font-size: 20px;margin-right:10px;color: #bababe;"></i>
                <el-input  type="textarea" :rows="1" v-model="currSmalltask.description"  @keyup.enter.native="addDescription" placeholder="添加描述"></el-input>
            </div>
            <div class="flex  align-center marginbot15">
                <i class="el-icon-user" style="font-size: 20px;margin-right:10px;color: #bababe;"></i>
                <div class="dutyleaderbox flex  align-center">
                    <div class="dutyleaderlogo">
                        <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="">
                    </div>
                    <div class="name">{{currSmalltask.dutyleader}}</div>
                    <i class="el-icon-close" @click="cancelDutyleader"></i>
               </div>
            </div>
            <div class="flex  align-center marginbot15">
                <i class="el-icon-date" style="font-size: 20px;margin-right:10px;color: #bababe;"></i>
                <div class="endtimebox flex  align-center">
                    <div class="name">{{currSmalltask.time}}</div>
                    <i class="el-icon-close" @click="cancelDutyleader"></i>
               </div>
            </div>
            <div class="flex  align-center marginbot15">
                <i class="el-icon-notebook-2" style="font-size: 20px;margin-right:10px;color: #bababe;"></i>
                <div class="endtimebox flex  align-center">
                    <div class="name">干细胞APP</div>
                    <el-select v-model="groupValue" filterable placeholder="请选择分组">
                        <el-option
                          v-for="item in groupData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                    </el-select>
                    <i class="el-icon-close" @click="cancelGroupValue"></i>
               </div>
            </div>
            <div class="flex  align-center marginbot15">
                <i class="el-icon-plus"></i>
                <div class="graytextcolor">添加至协作清单</div>
            </div>
            <div class="flex marginbot15">
                <i class="el-icon-rank"></i>
                <div class="rightcont">
                    <div class="process flex  align-center marginbot15">
                        <div>1/2</div>
                        <el-progress :percentage="50"></el-progress>
                    </div>
                    <div class="childtaskbox">
                        <div v-for="(item,index) in currSmalltask.childChildlist" :key="index" class="flex  align-center justify-between" style="margin-bottom:10px;">
                            <div class="flex  align-center">
                                <el-checkbox v-model="item.status " @change="changeChildtaskStatus(item.status)" style="margin-right:15px;"></el-checkbox>
                                <div :class="item.status ? 'distoryTaskname' : ''">{{ item.childtaskname }}</div>
                            </div>
                            <div class="threetool flex  align-center">
                                <div v-if="item.time" class="flex align-center">{{ item.time }}</div>
                                <div class="onetool flex  align-center" v-else> 
                                        <el-date-picker
                                                v-model="drawerEndtime"
                                                @change="drawerEndtimeChenge"
                                                type="datetime"
                                                placeholder="选择日期时间">
                                            </el-date-picker>
                                        <i class="el-icon-bank-card" style="font-size: 18px;margin-right:10px;color: #bababe;"></i>
                                </div>
                                <div v-if="item.dutyleader" class="flex align-center">
                                            <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 20px;height: 20px;border-radius: 50%;margin-right: 10px;">
                                </div>
                                <div class="onetool" v-else> 
                                    <el-popover
                                            placement="right"
                                            width="170"
                                            trigger="click">
                                            <div  class="dutyList">
                                                <el-input placeholder="请选择责任人" v-model="dutyleader" style="width:170px;"></el-input>
                                                <div v-for="(item,index) in dutyList" :key="index" @click="selectedThisdutyLeader(index,'childchildTask')" class="flex align-center" style=" margin-top: 8px;">
                                                    <img src="../../assets/images/cooperateManagement/memberlogo.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;margin-right:10px;margin-left:10px;">
                                                    <div>{{ item.dutyname }}</div>
                                                </div>
                                            </div>
                                            <i class="el-icon-user" slot="reference" @click="showChildchildDutyleaderList(index)" style="font-size: 18px;margin-right:10px;color: #bababe;"></i>
                                    </el-popover>
                                </div>
                                <div class="onetool"> <i class="el-icon-arrow-right" style="font-size: 18px;margin-right:10px;color: #bababe;"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="flex  align-center marginbot15" v-if="isShowChildinput">
                        <i class="el-icon-caret-right" style="margin-right:15px;"></i>
                        <el-input  v-model="newChildtask"  @keyup.enter.native="addChildtask" clearable  style="width: 200px;"  placeholder="请输入子任务名称" ></el-input>
                    </div>
                    <div class="flex  align-center marginbot15" @click="showAddChildTaskinput">
                        <i class="el-icon-circle-plus-outline"></i>
                        <div class="graytextcolor" >新增子任务</div>
                    </div>
                </div>
            </div>
            <div class=" marginbot15">
                <el-upload
                    class="upload-demo"
                    :action="$uploadURL"
                    :on-preview="handlePreviewDocument"
                    :on-remove="handleRemoveDocument"
                    :file-list="documentList"
                    :on-success="handleSuccessDocument">
                    <div class="flex align-center">
                        <i class="el-icon-paperclip"></i>
                        <div class="graytextcolor" >添加附件</div>
                    </div>
                </el-upload>
            </div>
        </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
    data() {
        return {
            activeNames1: ['1'],
            activeNames2: ['1'],
            fastmeauList:["全部任务","我创建的","我分配的","已完成"],
            cooperateList:["项目1","项目2"],
            activeProjectIndex:null,
            // 协作清单弹窗
            dialogVisibleAddProject:false,
            projectName:"",
            newBigName:"",
            newTaskName:"",
            x:"",
            y:"",
            // 项目名的小菜单
            isShowBigmeau:false,
            tabsList:["列表","看板"],
            activeIndex:0,
            // 默认分组列表
            defaultList:[
                {
                    status:false,
                    smalltaskname:"首页规划",
                    dutyleader:"",
                    dutyleaderLogo:"",
                    time:"18:00",
                    creator:"小明",
                    creatorLogo:"",
                },
               
            ],
            // 其他任务分组列表
            TaskList:[
                {
                    taskname:"产品分组",
                    tasknum:2,
                    childtask:[
                        {
                            status:false,
                            smalltaskname:"首页规划",
                            dutyleader:"",
                            dutyleaderLogo:"",
                            time:"2020-10-01 18:00",
                            creator:"小明",
                            creatorLogo:"",
                            childChildlist:[],
                        },
                        {
                            status:true,
                            smalltaskname:"首页规划",
                            dutyleader:"",
                            dutyleaderLogo:"",
                            time:"2020-10-01 18:00",
                            creator:"小明",
                            creatorLogo:"",
                            childChildlist:[],
                        }
                    ] 
                },
                {
                    taskname:"UI分组",
                    tasknum:6,
                    childtask:[{
                        smalltaskname:"首页规划",
                        dutyleader:"",
                        dutyleaderLogo:"",
                        time:"2020-10-01 18:00",
                        creator:"小明",
                        creatorLogo:"",
                        childChildlist:[],
                    }] 
                },
                {
                    taskname:"UI分组",
                    tasknum:6,
                    childtask:[{
                        smalltaskname:"首页规划",
                        dutyleader:"",
                        dutyleaderLogo:"",
                        time:"2020-10-01 18:00",
                        creator:"小明",
                        creatorLogo:"",
                        childChildlist:[],
                    }] 
                },
                {
                    taskname:"UI分组",
                    tasknum:6,
                    childtask:[{
                        smalltaskname:"首页规划",
                        dutyleader:"",
                        dutyleaderLogo:"",
                        time:"2020-10-01 18:00",
                        creator:"小明",
                        creatorLogo:"",
                        childChildlist:[],
                    }] 
                },
                {
                    taskname:"UI分组",
                    tasknum:6,
                    childtask:[{
                        smalltaskname:"首页规划",
                        dutyleader:"",
                        dutyleaderLogo:"",
                        time:"2020-10-01 18:00",
                        creator:"小明",
                        creatorLogo:"",
                        childChildlist:[],
                    }] 
                }
            ],
            // 给默认分组添加小任务
            isShowInputDefaulttask:false,
            inputDefaultTaskname:"",
            // 添加分组
            isShowInputFirstTask:false,
            inputFirstTaskname:"",
            // 给其他分组里添加小任务
            // isShowInputSecondTask:false,
            inputSecondTaskname:"",
            taskIndex:"",
            isShowTwomeau:false,
            isForm:"",    //点击的重命名来源    
            // 默认分组责任人弹窗
            defaultIndex:"",
            dutyleader:"",
            dutyList:[
                {
                    dutyleaderLogo:"",
                    dutyname:"张三"
                },
                {
                    dutyleaderLogo:"",
                    dutyname:"王五"
                },
            ],
            //选择结束时间
            endtime:"",
            //其他分组责任人弹窗
            otherIndex:"",
            childIndex:"",
            // 抽屉
            isShowdrawer:false,
            currSmalltask:{},
            groupValue:"",
            groupData:[
                '默认分组',
                'UI分组',
                '需求分组',
            ],
            newChildtask:'',  //新增子任务
            isShowChildinput:false,
            childchildIndex:"",
            drawerEndtime:"",   //抽屉的结束时间
            documentList:[],     //附件列表
        }
    },
    methods:{
        handleChangeTitle1(){

        },
        handleChangeTitle2(){

        },
        handleChangeTitle3(){

        },
        // 添加协作清单
        addProject(){
            this.isForm = "addProject"
            this.projectName = '';
            this.newBigName = "";
            this.newTaskName = "";
            this.dialogVisibleAddProject=true;
        },
        handleCloseAddProject(){
            this.dialogVisibleAddProject=false;
        },
        cancelAddProject(){
            this.dialogVisibleAddProject=false;
        },
        saveAddProject(){
            if(this.isForm =="addProject"){
                if(this.projectName===""){
                    this.$notify.info({
                        title: "提示",
                        message: "清单名称不允许为空",
                        showClose: true,
                    });
                    this.dialogVisibleAddProject = false;
                    return
                }else{
                    if(this.cooperateList.length ==0){
                        this.cooperateList.push(this.projectName);
                            this.dialogVisibleAddProject = false;
                            this.$notify.success({
                                  title: "提示",
                                  message: "创建成功",
                                  showClose: true
                                });
                    }else {
                        let  hasthis = '0'
                        for(let i = 0;i<this.cooperateList.length;i++){
                            if( this.cooperateList[i]== this.projectName){
                                hasthis = '1';
                                this.$notify.error({
                                  title: "提示",
                                  message: "清单名称不允许重复",
                                  showClose: true
                                });
                            }
                        }
                        if(hasthis == '0'){
                            this.cooperateList.push(this.projectName);
                            this.dialogVisibleAddProject = false;
                            this.$notify.success({
                                  title: "提示",
                                  message: "创建成功",
                                  showClose: true
                                });
                        }
                    }
                
                }
            }
            if(this.isForm =="taskName"){
                this.TaskList[this.taskIndex].taskname = this.newTaskName;
                this.dialogVisibleAddProject =false;
                this.isShowTwomeau = false;
                this.$notify.success({
                      title: "提示",
                      message: "修改成功",
                      showClose: true
                    });
            }
            
        },
        activeNowProject(index){
            this.activeProjectIndex = index;
        },
        // 协作清单的小菜单
        showLittleMeau(e){
            this.x = e.pageX //获取鼠标的X坐标（鼠标与屏幕左侧的距离，单位为px）
            this.y = e.pageY //获取鼠标的Y坐标（鼠标与屏幕顶部的距离，单位为px）
            console.log('xy==',this.x,this.y);
            document.querySelector('.smallmeau').classList.add("nowposition")
            // let meauclick = document.querySelector('.footer-x')
            // meauclick.onclick = function() {
            //     console.log(111);
            //     document.querySelector('#app').classList.add("noshowCodebox")
            // }
            // document.getElementById("box").setAttribute("style","color:red;")
        },
        // 项目名称的小菜单
        showBigMeau(){
            this.isShowBigmeau = !this.isShowBigmeau;
        },
        shareProject(){

        },
        changeProjectname(){
            this.isForm = 'bigName';
            this.dialogVisibleAddProject = true;
        },
        deleteProject(){

        },
        // 点击切换栏目
        changeTap(e) {
              this.activeIndex = e.currentTarget.dataset.index;
        },
        // 展示默认分组的输入框
        showInputDefaulttask(){
            this.isShowInputDefaulttask = true;
            this.inputDefaultTaskname="";
        },
        addDefaultTask(){
            if(this.defaultList.length ==0){
                this.defaultList.push({'smalltaskname':this.inputDefaultTaskname})
                this.isShowInputDefaulttask =false;
                    this.$notify.success({
                          title: "提示",
                          message: "创建成功",
                          showClose: true
                        });
                }else {
                    let  hasthis = '0'
                    for(let i = 0;i<this.defaultList.length;i++){
                        if( this.defaultList[i].smalltaskname== this.inputDefaultTaskname)
                        {
                            hasthis = '1'
                            this.$notify.error({
                              title: "提示",
                              message: "任务名不允许重复",
                              showClose: true
                            });
                        }
                    }
                    if(hasthis == '0'){
                        this.defaultList.push({'smalltaskname':this.inputDefaultTaskname})
                        this.isShowInputDefaulttask =false;
                        this.$notify.success({
                              title: "提示",
                              message: "创建成功",
                              showClose: true
                            });
                    }   
                }
            
            console.log('this.defaultList== ',this.defaultList);
        },
        //任务名称的的小菜单
        showTwomeau(index){
            this.taskIndex = index;
            this.isShowTwomeau = !this.isShowTwomeau;
        },
        changeTaskName(index){
            this.isForm = 'taskName';
            this.dialogVisibleAddProject = true;
            this.taskIndex = index;
            // this.TaskList[index].taskname = this.newFirstname;
        },
        deleteTaskName(index){
            this.taskIndex = index;
            this.TaskList.splice(index,1);
            this.$notify.success({
                      title: "提示",
                      message: "删除成功",
                      showClose: true
            });
        },
        // 添加新的其他分组
        showInputtask(){
            this.isShowInputFirstTask = true;
            this.inputFirstTaskname="";
        },
        addTask(){
            if(this.TaskList.length ==0){
                this.TaskList.push({'taskname':this.inputFirstTaskname})
                this.isShowInputFirstTask =false;
                    this.$notify.success({
                          title: "提示",
                          message: "创建成功",
                          showClose: true
                        });
                }else {
                    let  hasthis = '0'
                    for(let i = 0;i<this.TaskList.length;i++){
                        if( this.TaskList[i].taskname== this.inputFirstTaskname)
                        {
                            hasthis = '1'
                            this.$notify.error({
                              title: "提示",
                              message: "任务名不允许重复",
                              showClose: true
                            });
                        }
                    }
                    if(hasthis == '0'){
                        this.TaskList.push({'taskname':this.inputFirstTaskname})
                        this.isShowInputFirstTask =false;
                        this.$notify.success({
                              title: "提示",
                              message: "创建成功",
                              showClose: true
                            });
                    }   
                }
            
            console.log('this.TaskList== ',this.TaskList);
        },
        // 添加其他分组里的小任务，展示其他分组的输入框
        showInputSecondTask(index){
            console.log("index==>",index);
            this.taskIndex = index;
            // this.isShowInputSecondTask = true;
            this.inputSecondTaskname = '';
        },
        addSecondTask(){
            let ii = this.taskIndex;
            if(this.TaskList[ii].childtask.length ==0){
                this.TaskList[ii].childtask.push({'smalltaskname':this.inputSecondTaskname})
               
                    this.$notify.success({
                          title: "提示",
                          message: "创建成功",
                          showClose: true
                        });
                    this.taskIndex ='';
                }else {
                    let  hasthis = '0'
                    for(let i = 0;i<this.TaskList[ii].childtask.length;i++){
                        if( this.TaskList[ii].childtask[i].smalltaskname== this.inputSecondTaskname) {
                            hasthis = '1'
                            this.$notify.error({
                              title: "提示",
                              message: "任务名不允许重复",
                              showClose: true
                            });
                        }
                    }
                    if(hasthis == '0'){
                        this.TaskList[ii].childtask.push({'smalltaskname':this.inputSecondTaskname})
                       
                        this.$notify.success({
                              title: "提示",
                              message: "创建成功",
                              showClose: true
                            });
                        this.taskIndex ='';
                    }   
                }
        },
        changeSecondtaskStatus(status){
            let status1 = status;
            console.log("status==>",status1);
        },
        // 默认分组添加责任人
        showDutyleaderList(index){
            this.defaultIndex = index;
        },
        // 其他分组添加责任人
        showOtherDutyleaderList(index1,index2){
            console.log('788787==>',index1,index2);    //确定当前点击的行在数组中的位置
            this.otherIndex =index1;
            this.childIndex =index2;
        },
        showChildchildDutyleaderList(index){
            this.childchildIndex=index;
        },
        selectedThisdutyLeader(index,from){
            this.dutyleader = this.dutyList[index].dutyname;
            if(from == "defaultTask"){
                // var dutyleaderlogo = this.dutyList[index].dutyleaderLogo;
                // this.defaultList[this.defaultIndex].dutyleaderLogo=dutyleaderlogo;
                this.defaultList[this.defaultIndex].dutyleader=this.dutyleader;
            }
            if(from == "otherTask"){
                // var dutyleaderlogo = this.dutyList[index].dutyleaderLogo;
                // this.defaultList[this.defaultIndex].dutyleaderLogo=dutyleaderlogo;
                this.TaskList[this.otherIndex].childtask[this.childIndex].dutyleader=this.dutyleader;
            }
            if(from == "childchildTask"){
                // var dutyleaderlogo = this.dutyList[index].dutyleaderLogo;
                // this.defaultList[this.defaultIndex].dutyleaderLogo=dutyleaderlogo;
                this.currSmalltask.childChildlist[this.childchildIndex].dutyleader=this.dutyleader;
            }
                this.$notify.success({
                          title: "提示",
                          message: "选择成功",
                          showClose: true
                        });
                this.dutyleader ="";            
        },
        
        // 展示抽屉
        showDrawer(smalltask){
            console.log('currSmalltask==>',smalltask);
            this.isShowdrawer = true;
            this.currSmalltask = smalltask;
        },
        // 添加描述
        addDescription(){
            
        },
        // 取消责任人
        cancelDutyleader(){

        },
        // 取消分组
        cancelGroupValue(){
            this.groupValue = "";
        },
        showAddChildTaskinput(){
            this.isShowChildinput = true;
        },
        addChildtask(){
           this.currSmalltask.childChildlist.push({'childtaskname':this.newChildtask}); 
            console.log('this.currSmalltask',this.currSmalltask);
            this.$notify.success({
                          title: "提示",
                          message: "选择成功",
                          showClose: true
                        });
                this.newChildtask ="";
                this.isShowChildinput = false;
        },
        changeChildtaskStatus(){

        },
        drawerEndtimeChenge(){

        },
        // 上传附件
        handlePreviewDocument(file){
            console.log('点击文件列表中已上传的文件==>',file);
        },
        handleRemoveDocument(file, fileList){
            console.log('文件列表移除文件==>',file);
        },
        handleSuccessDocument(file, fileList){
            let fileUrl = file.data.url;
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .el-main {
    background-color: #f5f6f7;
}
/deep/.el-tabs__header {
    // height: 0 !important;
    // display: none;
    margin: 0;
}
.navigation{
    color: #666666;
    font-size: 15px;
    background-color: #f5f6f7;
}
li {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    // border: 1px solid pink;
}
.title,
.meau {
        img {
        display: inline-block;
        width: 25px;
        height: 25px; 
        margin-right: 5px;   
   
    }
}
/deep/ .el-collapse-item__header,
/deep/ .el-collapse-item__content {
    color: #666666;
    font-size: 15px;
}
/deep/ .el-collapse-item__header{
    font-weight: 700;
}
/deep/ .el-collapse-item__wrap  {
    background-color: #f5f6f7;
}
// 协作清单的弹窗
/deep/.el-dialog__body {
    padding: 0 20px;
}
/deep/ .el-dialog__footer{
    background-color: #fff;
}
.projectname {
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 15px;
}
.activeproject {
    width: 100%;
    height: 35px;
    line-height: 35px;
    background-color: #fff;
}
.projecttitle {
    height: 50px;
box-sizing: border-box;
}
.bigMeau {
    position: absolute;
    top:40px;
    right:-100px;
    width: 130px;
    color: #333333;
    font-size: 15px;
    padding: 15px 10px;
    border-radius: 5px;
    background-color: #fff;
    z-index: 99;   
    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
    box-sizing: border-box;
    img {
        width: 25px;
        height: 25px;
    }
}
.twoMeau {
    position: absolute;
    top:40px;
    right:-100px;
    width: 100px;
    height: 60px;
    color: #333333;
    font-size: 13px;
    padding: 0px 5px;
    border-radius: 5px;
    background-color: #fff;
    z-index: 99;   
    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
    box-sizing: border-box;
    img {
        width: 20px;
        height: 20px;
    } 
    /deep/ .el-collapse-item__header {
        line-height: 30px !important;
    }
}
// el-col-21
.name {
    .bigtitle {
        font-size: 25px;
        font-weight: 700;
        color: #333333;
       

    }
}
.memberlogo {
    width: 50px;
    height: 50px;
    margin-right: 50px;
    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
}
// tab栏
.tabs {
    width: 100%;
    border-bottom: 2px solid #e4e6e8 ;
    .onetab {
        width: 80px;
        height: 50px;
        line-height: 50px;
        font-weight: 700;
        text-align: center;
        font-size: 16px;
        color: #2f3338;

    }
    .activetab {
        color:#3370ff;
        border-bottom: 2px solid #3370ff;
    }
}
.addnewTaskbox {
    width: 140px;
    height: 30px;
    line-height: 30px;
    color: #3370ff;
    font-size: 14px;
    border-radius: 5px;
    border: 1px solid #3370ff;
    margin-top: 20px;
    img{
        width: 20px;
        height: 20px;

    }
    .addnewTaskbox1 {
        width: 100px;
        img {
            margin-left: 10px;
           
        }
    }
    .addnewTaskbox2 {
        height: 30px;
        border-left: 1px solid #3370ff;
        img {
            margin-left: 10px;
        }
    }
}
.addnewTaskbox:hover {
    cursor: pointer;
}
.graytext {
    margin-top: 20px;
    color: #7b8189;
    font-weight: 700;
    font-size: 14px;
}
.bottomborder {
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e6e8;
}
// 列表1
.distoryTaskname {
        text-decoration:line-through;
        color: rgb(192, 196, 200);
    }
.content1 {
    .smalltaskname {
        color: #666666;
        // font-weight: 700;
    }
    /deep/ .el-collapse-item__wrap {
        background-color: #ffffff;
    }
   
    .dutyList{
        position: absolute;
        bottom: 20px;
        width: 180px;
        padding: 8px 5px;
        box-sizing: border-box;
        z-index: 9999;
        overflow: auto;
        background-color: #fff;
        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
    }
    .oneduty {
            margin-top: 8px;
        }

    .selecttime {
        /deep/.el-input__inner {
            border: none;
        }
    }
}
// 看板2
.content2::-webkit-scrollbar {
    display: none;      //隐藏滚动条
}
.content2 {
    margin-top: 15px;
    white-space: nowrap;
    display: flex;
    overflow: scroll;    //盒子横向滚动
    .blocktitle {
        color: #333333;
        font-weight: 700;
        font-size: 15px;
        margin-bottom: 15px;
    }
    .oneblock {
        width: 250px;
       
        padding: 10px 10px;
        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
        border-radius: 5px;
        margin-bottom: 15px;
        // border: 1px solid #84a7fc;
        /deep/.el-input--small {
            width: 200px;
            
        }
        /deep/.el-input--suffix .el-input__inner {
            padding-right: 5px;
        }
        /deep/.el-input__inner {
            border: none;
        }
        .memberbox {
            margin-left:25px;
            .memberlogo {
                width: 25px;
                height: 25px;  
                margin-right: 10px;     
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
        }
    }
}
//抽屉
.drawer {
    padding-left:20px;
    padding-right: 20px;
    box-sizing: border-box;
}
.marginbot15 {
    margin-bottom: 15px;
}
.currsmalltaskname {
    font-weight: 700;
    color: #1e1e1e;
    font-size: 20px;
    margin-bottom: 20px;
}
.dutyleaderbox {
   padding-right: 10px;
    height: 40px;
    border-radius: 20px;
    background-color: #f4f4f4;
    .dutyleaderlogo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .name {
        font-size: 15px;
        margin-right: 10px;
    }
}
.endtimebox {
    font-size: 15px;
    .name {
        padding:0 8px;
        height: 35px;
        line-height: 35px;
        border-radius: 5px;
        background-color: #f4f4f4;
        margin-right: 10px;
    }
}
.graytextcolor {
    color:#666666;
    font-size: 15px;
    margin-left: 15px;

}
.rightcont {
    margin-left: 15px;
    flex: 1;
    .el-progress {
        width: 200px;
        margin-left: 15px;
    }
}
// 抽屉的时间选择器
.onetool .el-date-editor.el-input{
width: 36px;
position: relative;
right: -20px;
opacity: 0;
}
.onetool /deep/.el-input--prefix .el-input__inner {
padding-left: 0;
} 
.onetool /deep/.el-input--suffix .el-input__inner{
padding-right: 0;
} 
</style>